import { render, staticRenderFns } from "./shopUserList.vue?vue&type=template&id=5a0954f0"
import script from "./shopUserList.vue?vue&type=script&lang=js"
export * from "./shopUserList.vue?vue&type=script&lang=js"
import style0 from "./shopUserList.vue?vue&type=style&index=0&id=5a0954f0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports